import { Application, Container } from "pixi.js";

// Логическое поле 1024×768, масштабируется с сохранением пропорций,
// центрируется, вокруг — полосы (iPhone). touch-action: none и запрет
// масштабирования страницы задаются в style.css.

export const LOGICAL_W = 1024;
export const LOGICAL_H = 768;

export interface Stage {
  app: Application;
  root: Container; // рисуем сюда в логических координатах
  /** Экранные координаты pointer → логические координаты сцены. */
  toLogical(clientX: number, clientY: number): { x: number; y: number };
}

export async function createStage(mount: HTMLElement): Promise<Stage> {
  const app = new Application();
  await app.init({
    background: "#0b1026",
    antialias: true,
    resolution: Math.min(window.devicePixelRatio || 1, 2),
    autoDensity: true,
    powerPreference: "high-performance",
  });
  mount.appendChild(app.canvas);

  const root = new Container();
  app.stage.addChild(root);

  let scale = 1;
  let offsetX = 0;
  let offsetY = 0;

  const resize = () => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    app.renderer.resize(w, h);
    scale = Math.min(w / LOGICAL_W, h / LOGICAL_H);
    offsetX = (w - LOGICAL_W * scale) / 2;
    offsetY = (h - LOGICAL_H * scale) / 2;
    root.scale.set(scale);
    root.position.set(offsetX, offsetY);
  };
  resize();
  window.addEventListener("resize", resize);
  window.addEventListener("orientationchange", () => setTimeout(resize, 200));

  return {
    app,
    root,
    toLogical(clientX, clientY) {
      const rect = app.canvas.getBoundingClientRect();
      return {
        x: (clientX - rect.left - offsetX) / scale,
        y: (clientY - rect.top - offsetY) / scale,
      };
    },
  };
}
